import React, { Component } from 'react';
import '../pages/styles/home.css';
import ParticleComponent from "../components/ParticleComponent"

export class home extends Component {
    render() {
        return (
            <div className="Hero">
          <ParticleComponent/>
          <div className="HeroTitle">
            {/*<h1>Hi,<br/>I'm Laurenz,<br/>computer science student.</h1>*/}

            <h1 className="blast-root">
              <span className="blast" >H</span>
              <span className="blast" >i</span>
              <span className="blast" >,</span>
              <br/>
              <span className="blast" >I</span>
              <span className="blast" >'</span>
              <span className="blast" >m</span>
              <span className="blast" > </span>
              <span className="blast" >L</span>
              <span className="blast" >a</span>
              <span className="blast" >u</span>
              <span className="blast" >r</span>
              <span className="blast" >e</span>
              <span className="blast" >n</span>
              <span className="blast" >z</span>
              <span className="blast" >,</span>
              <br/>
              <span className="blast" >c</span>
              <span className="blast" >o</span>
              <span className="blast" >m</span>
              <span className="blast" >p</span>
              <span className="blast" >u</span>
              <span className="blast" >t</span>
              <span className="blast" >e</span>
              <span className="blast" >r</span>
              <span className="blast" > </span>
              <span className="blast" >s</span>
              <span className="blast" >c</span>
              <span className="blast" >i</span>
              <span className="blast" >e</span>
              <span className="blast" >n</span>
              <span className="blast" >c</span>
              <span className="blast" >e</span>
              <span className="blast" > </span>
              <span className="blast" >s</span>
              <span className="blast" >t</span>
              <span className="blast" >u</span>
              <span className="blast" >d</span>
              <span className="blast" >e</span>
              <span className="blast" >n</span>
              <span className="blast" >t</span>
              <span className="blast" >.</span>
            </h1>
          </div>
        </div>
        )
    }
}

export default home
